// Missing several props and methods from core implementation

import React from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryQuotationEditor } from '@bibliocommons/shared-ugc-editors';
import { currentUserSelector } from '../../selectors/AuthSelector';

class PrimaryQuotationEditorContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      quotation: null,
      isNew: true,
      userContentId: null,
      showForm: true,
      expanded: false,
      initializingStatus: {
        status: 'success',
        localeKey: null
      },
      user: props.user
    };

    this.bindAll('handleChange');
  }

  static handleLogin(e) {
    e.preventDefault();
  }

  static handleSubmit(e) {
    e.preventDefault();
  }

  handleChange(value) {
    this.setState({
      quotation: value
    });
  }

  render() {
    return (
      <PrimaryQuotationEditor
        characterLimit={4000}
        quotation={this.state.quotation}
        handleLogin={PrimaryQuotationEditorContainer.handleLogin}
        handleChange={this.handleChange}
        isNew={this.state.isNew}
        handleSubmit={PrimaryQuotationEditorContainer.handleSubmit}
        messages={this.props.messages}
        user={this.state.user}
        initializingStatus={this.state.initializingStatus} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = currentUserSelector(state);
  const editorUser = user ? {
    loggedIn: true,
    id: user.id,
    // idHash: '',
    allowFreeText: true
  } : { loggedIn: false };

  return {
    bibId: ownProps.bibId,
    metadataId: ownProps.metadataId,
    user: editorUser
  };
};

export default connect(mapStateToProps)(PrimaryQuotationEditorContainer);



// WEBPACK FOOTER //
// ./app/containers/UGCTestContainers/PrimaryQuotationEditorContainer.jsx